(function () {
  'use strict';

  function fmt(cents) {
    return 'Rs. ' + Math.round(cents / 100).toLocaleString('en-US');
  }

  var cartTotal = null;

  function paint(el, total) {
    var min = parseInt(el.dataset.min, 10);
    var max = parseInt(el.dataset.max, 10);
    var title = el.querySelector('.tm-cod__title');
    var sub = el.querySelector('.tm-cod__sub');
    var prog = el.querySelector('.tm-cod__prog span');
    el.classList.remove('tm-cod--ok', 'tm-cod--below', 'tm-cod--above');
    if (total < min) {
      el.classList.add('tm-cod--below');
      title.textContent = 'Add ' + fmt(min - total) + ' more to pay cash on delivery';
      sub.textContent = el.dataset.belowSub;
      if (prog) prog.style.width = Math.min(100, Math.round((total / min) * 100)) + '%';
    } else if (total > max) {
      el.classList.add('tm-cod--above');
      title.textContent = el.dataset.aboveTitle;
      sub.textContent = el.dataset.aboveSub;
    } else {
      el.classList.add('tm-cod--ok');
      title.textContent = el.dataset.okText;
      sub.textContent = '';
    }
  }

  function productTotal(el) {
    var form = document.querySelector('product-form form, form[data-type="add-to-cart-form"]');
    var qty = 1;
    var price = parseInt(el.dataset.base, 10) || 0;
    if (form) {
      var q = form.querySelector('[name="quantity"]');
      if (q && q.value) qty = parseInt(q.value, 10) || 1;
    }
    return (cartTotal || 0) + price * qty;
  }

  function refresh() {
    var els = document.querySelectorAll('[data-tm-cod][data-context="product"]');
    if (!els.length) return;
    els.forEach(function (el) { paint(el, productTotal(el)); });
  }

  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cartTotal = c.total_price; refresh(); })
      .catch(function () {});
  }

  function setVariantPrice(price) {
    document.querySelectorAll('[data-tm-cod][data-context="product"]').forEach(function (el) {
      el.dataset.base = price;
    });
    refresh();
  }

  function subscribeAll() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(loadCart, 250); });
      if (PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
          if (e && e.data && e.data.variant && e.data.variant.price != null) {
            setVariantPrice(e.data.variant.price);
          }
        });
      }
    } else {
      setTimeout(subscribeAll, 400);
    }
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('product-form [name="quantity"], .product-form [name="quantity"]')) {
      refresh();
    }
  });

  function init() {
    if (document.querySelector('[data-tm-cod][data-context="product"]')) loadCart();
    subscribeAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
